import { Table } from '@billy/design-system'
import isNil from 'lodash/isNil'
import { ReactElement } from 'react'

import { ContactPerson } from '@modules-deprecated/app/contactPerson/types/contactPerson'

import { TableIds } from '../../../../../../enums/tableIds'
import { useContactDetail } from '../../contexts/contactDetailContext'
import { ContactPersonModal, CREATE_CONTACT_PERSON_MODAL_ID } from './elements/ContactPersonModal'
import { ContactPersonsEmptyState } from './elements/ContactPersonsEmptyState'
import { useContactPersonsTableColumns } from './hooks/useContactPersonsTableColumns'
import { useContactPersonsTableData } from './hooks/useContactPersonsTableData'

export const ContactPersonsTable = (): ReactElement => {
  const { contact } = useContactDetail()
  const contactPersons = (contact.contactPersons ?? []).filter(
    (contactPerson): contactPerson is ContactPerson =>
      !isNil(contactPerson.id) && !!(contactPerson.name || contactPerson.email),
  )

  const columns = useContactPersonsTableColumns()
  const tableData = useContactPersonsTableData(contactPersons)

  return (
    <>
      {contactPersons.length === 0 ? (
        <ContactPersonsEmptyState />
      ) : (
        <Table
          columns={columns}
          data={tableData}
          id={TableIds.ContactPersonsTable}
          withColumnsFiltering={false}
          withPagination={false}
        />
      )}
      <ContactPersonModal contactId={contact.id} id={CREATE_CONTACT_PERSON_MODAL_ID} />
    </>
  )
}
